module.exports = __webpack_public_path__ + "static/media/donttitle.b010f84e.png";